import React from 'react'
import {
  PixelCurrency,
  PixelDate,
  PixelTable,
  PixelTag,
  Section,
  SectionContent,
} from 'pixel-base'

const columns = [
  {
    dataKey: 'invoice_id',
    name: 'ID',
    sortable: true,
    selector: (row) => row.invoice_id || '--',
  },
  {
    dataKey: 'source_order_id',
    name: 'Invoice #',
    sortable: true,
    selector: (row) => row.source_order_id || '--',
  },
  {
    dataKey: 'invoice_status',
    name: 'Invoice Status',
    sortable: true,
    selector: (row) =>
      <PixelTag className="success">{row.invoice_status}</PixelTag> || '--',
  },
  {
    dataKey: 'date_created',
    name: 'Date',
    sortable: true,
    selector: (row) => <PixelDate value={row.date_created} /> || '--',
  },
  // {
  //   dataKey: 'city',
  //   name: 'City',
  //   sortable: true,
  //   selector: (row) => row.city || '--',
  // },
  {
    dataKey: 'total',
    name: 'Amount',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.total} currency={'USD'} /> || '--',
  },
]

const OrderHistory = (props) => {
  const { customer } = props

  return (
    <>
      <Section>
        <SectionContent>
          <PixelTable
            columns={columns}
            data={customer.invoices}
            progressPending={false}
          />
        </SectionContent>
      </Section>
    </>
  )
}

export default OrderHistory
